import { createContext, useState, useEffect } from 'react';

const DataContext = createContext({

  step1: { companyName: '', email: '', managerName: '', managerNumber: '', companyWebsite: '', companyDescription: '', backgroundColor: '#FFFFFF', companyId: null, companyLogo: null, facebookPage: '', instagramProfile: '', pinterestProfile: '' },
  step2: {},
  step3: { activeTab: 1, data: { deal: 1, dealUnit: "Free", dealItem: 'T-Shirt' } },
  step4: { cost: 0, durationType: 'days', duration: 0 },
  step5: { couponCode: '', couponWebsite: '', couponPhone: '', couponEmail: '', couponDescription: '' },
  step6: { terms: [], instructions: [] },
  step7: { locations: [], isOnlineOnly: false, countries: [], isGlobal: false },
  step8: { categories: [] },
  payment: { amount: 0, customerEmail: '', customerName: '', paymentStatus: 'pending' },
  companyId: null,
  couponId: null,
  userCountry: 'us',
  selectedDeal: '',
  setStep1: (step1) => { },
  setStep2: (step2) => { },
  setStep3: (step3) => { },
  setStep4: (step4) => { },
  setStep5: (step5) => { },
  setStep6: (step6) => { },
  setStep7: (step7) => { },
  setStep8: (step8) => { },
  setStep9: (step9) => { },
  setPayment: (payment) => { },
  setCompanyId: (id) => { },
  setCouponId: (id) => { },
  setUserCountry: (country) => { },
  setSelectedDeal: (deal) => { },
  createCompanyDraft: () => { },
  clearAllData: () => { },
});

export function DataContextProvider(props) {

  // Load initial state from localStorage
  const getInitialState = (key, defaultValue) => {
    try {
      const stored = localStorage.getItem(`couponData_${key}`);
      return stored ? JSON.parse(stored) : defaultValue;
    } catch (error) {
      console.error(`Error loading ${key} from localStorage:`, error);
      return defaultValue;
    }
  };

  const [step1, setStep1] = useState(() => getInitialState('step1', { companyName: '', email: '', managerName: '', managerNumber: '', companyWebsite: '', companyDescription: '', backgroundColor: '', companyId: null, companyLogo: null, facebookPage: '', instagramProfile: '', pinterestProfile: '' }));
  const [step2, setStep2] = useState(() => getInitialState('step2', {}));
  const [step3, setStep3] = useState(() => getInitialState('step3', { activeTab: 1, data: { deal: 1, dealUnit: "Free", dealItem: 'T-Shirt' } }));
  const [step4, setStep4] = useState(() => getInitialState('step4', { cost: 0, durationType: 'days', duration: 0 }));
  const [step5, setStep5] = useState(() => getInitialState('step5', { couponCode: '', couponWebsite: '', couponPhone: '', couponEmail: '', couponDescription: '' }));
  const [step6, setStep6] = useState(() => getInitialState('step6', { terms: [], instructions: [] }));
  const [step7, setStep7] = useState(() => getInitialState('step7', { locations: [], isOnlineOnly: false, countries: [], isGlobal: false }));
  const [step8, setStep8] = useState(() => getInitialState('step8', { categories: [] }));
  const [payment, setPayment] = useState(() => getInitialState('payment', { amount: 0, customerEmail: '', customerName: '', paymentStatus: 'pending' }));
  const [companyId, setCompanyId] = useState(() => getInitialState('companyId', null));
  const [couponId, setCouponId] = useState(() => getInitialState('couponId', null));
  const [userCountry, setUserCountry] = useState(() => getInitialState('userCountry', 'us'));
  const [selectedDeal, setSelectedDeal] = useState(() => getInitialState('selectedDeal', ''));

  // Save to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('couponData_step1', JSON.stringify(step1));
  }, [step1]);

  useEffect(() => {
    localStorage.setItem('couponData_step2', JSON.stringify(step2));
  }, [step2]);

  useEffect(() => {
    localStorage.setItem('couponData_step3', JSON.stringify(step3));
  }, [step3]);

  useEffect(() => {
    localStorage.setItem('couponData_step4', JSON.stringify(step4));
  }, [step4]);

  useEffect(() => {
    localStorage.setItem('couponData_step5', JSON.stringify(step5));
  }, [step5]);

  useEffect(() => {
    localStorage.setItem('couponData_step6', JSON.stringify(step6));
  }, [step6]);

  useEffect(() => {
    localStorage.setItem('couponData_step7', JSON.stringify(step7));
  }, [step7]);

  useEffect(() => {
    localStorage.setItem('couponData_step8', JSON.stringify(step8));
  }, [step8]);

  useEffect(() => {
    localStorage.setItem('couponData_payment', JSON.stringify(payment));
  }, [payment]);

  useEffect(() => {
    localStorage.setItem('couponData_companyId', JSON.stringify(companyId));
  }, [companyId]);

  useEffect(() => {
    localStorage.setItem('couponData_couponId', JSON.stringify(couponId));
  }, [couponId]);

  useEffect(() => {
    localStorage.setItem('couponData_userCountry', JSON.stringify(userCountry));
  }, [userCountry]);

  useEffect(() => {
    localStorage.setItem('couponData_selectedDeal', JSON.stringify(selectedDeal));
  }, [selectedDeal]);

  function setStep1Handler(data) {
    setStep1(data);
  }
  function setStep2Handler(data) {
    setStep2(data);
  }
  function setStep3Handler(data) {
    setStep3(data);
  }
  function setStep4Handler(data) {
    setStep4(data);
  }
  function setStep5Handler(data) {
    setStep5(data);
  }
  function setStep6Handler(data) {
    setStep6(data);
  }
  function setStep7Handler(data) {
    setStep7(data);
  }
  function setStep8Handler(data) {
    setStep8(data);
  }

  function setPaymentHandler(data) {
    setPayment(data);
  }

  function setCompanyIdHandler(id) {
    setCompanyId(id);
  }

  function setCouponIdHandler(id) {
    setCouponId(id);
  }

  function setUserCountryHandler(country) {
    setUserCountry(country);
  }

  function setSelectedDealHandler(deal) {
    setSelectedDeal(deal);
  }

  const createCompanyDraft = async () => {
    const payload = {
      "company_name": step1.companyName,
      "background_color": step1.backgroundColor || '#FFFFFF',
      "email_address": step1.email,
      "phone_number": step1.managerNumber,
      "description": step1.companyDescription,
      "contact_person": step1.managerName,
      "website": step1.companyWebsite,
      "listingType": "coupon"
    }

    // Add social media fields if they exist
    if (step1.facebookPage && step1.facebookPage.trim() !== '') {
      payload.facebook_page = step1.facebookPage;
    }
    if (step1.instagramProfile && step1.instagramProfile.trim() !== '') {
      payload.instagram_profile = step1.instagramProfile;
    }
    if (step1.pinterestProfile && step1.pinterestProfile.trim() !== '') {
      payload.pinterest_profile = step1.pinterestProfile;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URI}/v3/advertising`, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      })
      const data = await res.json()

      if (data.status === 'success' || res.ok) {
        const companyId = data.data?.id || data.id || data.company_id;
        setCompanyId(companyId);
        console.log('Company ID:', companyId);
        return { success: true, companyId: companyId };
      } else {
        return { success: false, error: data.message || 'Failed to create company' };
      }
    } catch (error) {
      console.error('Error creating company draft:', error);
      return { success: false, error: 'Network error occurred' };
    }
  }

  const clearAllData = () => {
    // Clear all state
    setStep1({ companyName: '', email: '', managerName: '', managerNumber: '', companyWebsite: '', companyDescription: '', backgroundColor: '#FFFFFF', companyId: null, companyLogo: null, facebookPage: '', instagramProfile: '', pinterestProfile: '' });
    setStep2({});
    setStep3({ activeTab: 1, data: { deal: 1, dealUnit: "Free", dealItem: 'T-Shirt' } });
    setStep4({ cost: 0, durationType: 'days', duration: 0 });
    setStep5({ couponCode: '', couponWebsite: '', couponPhone: '', couponEmail: '', couponDescription: '' });
    setStep6({ terms: [], instructions: [] });
    setStep7({ locations: [], isOnlineOnly: false, countries: [], isGlobal: false });
    setStep8({ categories: [] });
    setPayment({ amount: 0, customerEmail: '', customerName: '', paymentStatus: 'pending' });
    setCompanyId(null);
    setCouponId(null);
    setUserCountry('us');
    setSelectedDeal('');

    // Clear all localStorage items
    localStorage.removeItem('couponData_step1');
    localStorage.removeItem('couponData_step2');
    localStorage.removeItem('couponData_step3');
    localStorage.removeItem('couponData_step4');
    localStorage.removeItem('couponData_step5');
    localStorage.removeItem('couponData_step6');
    localStorage.removeItem('couponData_step7');
    localStorage.removeItem('couponData_step8');
    localStorage.removeItem('couponData_payment');
    localStorage.removeItem('couponData_companyId');
    localStorage.removeItem('couponData_couponId');
    localStorage.removeItem('couponData_userCountry');
    localStorage.removeItem('couponData_selectedDeal');
  }

  const context = {
    step1: step1,
    step2: step2,
    step3: step3,
    step4: step4,
    step5: step5,
    step6: step6,
    step7: step7,
    step8: step8,
    payment: payment,
    companyId: companyId,
    couponId: couponId,
    userCountry: userCountry,
    selectedDeal: selectedDeal,
    setStep1: setStep1Handler,
    setStep2: setStep2Handler,
    setStep3: setStep3Handler,
    setStep4: setStep4Handler,
    setStep5: setStep5Handler,
    setStep6: setStep6Handler,
    setStep7: setStep7Handler,
    setStep8: setStep8Handler,
    setPayment: setPaymentHandler,
    setCompanyId: setCompanyIdHandler,
    setCouponId: setCouponIdHandler,
    setUserCountry: setUserCountryHandler,
    setSelectedDeal: setSelectedDealHandler,
    createCompanyDraft: createCompanyDraft,
    clearAllData: clearAllData,
  };

  return <DataContext.Provider value={context}>
    {props.children}
  </DataContext.Provider>
}

export default DataContext;